// Adobe Analytics common library to set up
// Please refer to: https://helpx.adobe.com/content/dam/help/en/experience-manager/kt/integration/using/launch-reference-architecture-guides/_jcr_content/main-pars/download_section_172138899/download-1/launch_referencearchitectureguide-spa-reactjswithredux.pdf

// This event should be fired when the actual view/stage/page has finished loading. (usually inside componentDidMount)
const fireViewEndCustomEvent = () => {
    console.log("event-view-end");
    const event = new CustomEvent('event-view-end');
    const obj = document.querySelector("body");
    if(obj){
        obj.dispatchEvent(event);
    }
};

export {
    fireViewEndCustomEvent
}